import React from "react";
import InternalAppBar from "./app-bar";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { PaletteMode } from "@mui/material";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import { useEffect, useState } from "react";

function Internal() {
  const [mode] = useState<PaletteMode>("dark");
  const defaultTheme = createTheme({
    palette: { mode },
  });

  useEffect(() => {
    logEvent(analytics, "private_internal_page_load");
  }, []);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <InternalAppBar />
    </ThemeProvider>
  );
}

export default Internal;
